import EmptyList from '@components/ResourceList/EmptyList/EmptyList'
import ResourceList from '@components/ResourceList/ResourceList'
import { useListParams } from '@hooks/useListParams'
import { useQueryListData } from '@hooks/useQueryListData'
import type { ResourceScope } from 'src/types/global'

interface QueryListProps {
  scope: ResourceScope
}

export default function QueryList({ scope }: QueryListProps) {
  const items = useQueryListData(scope)
  const finalItems = useListParams(items)

  if (!items.length) {
    return <EmptyList variant="empty" type="query" />
  }
  if (!finalItems.length) {
    return <EmptyList variant="no-results" type="query" />
  }
  return <ResourceList type="query" items={finalItems} />
}
